import { LineChartComponentData } from '../../../../@types';
import { sanitizeKey } from '../../../../utils/dataUtils';

export interface ChartData {
  id: string;
  data: Array<{ x: string | number; y: string | number | null }>;
}

/**
 * Maps the data to a line chart in the format:
 * {
 *   id: aggrKey.id
 *   data: [{ x: groupBy[1].id, y: groupBy[2].id }]
 * }
 */
export const formatChartData = (
  aggrKey: LineChartComponentData['aggrKey'],
  data: Array<Record<string, string | number>>,
): Array<ChartData> =>
  data.map<ChartData>((d) => ({
    id: `${d[sanitizeKey(aggrKey.key)]}`,
    data: Object.entries(d)
      .filter(
        ([key]) => key !== sanitizeKey(aggrKey.key) && key !== '_original',
      )
      .map(([k, v]) => ({
        x: k,
        y: v || null,
      })),
  }));
